import * as React from "react";
import { SVGProps } from "react";
const SvgMailIcon = (props: SVGProps<SVGSVGElement>) => <svg width={31} height={22} viewBox="0 0 31 22" {...props}><g stroke="currentColor" strokeWidth={2} fill="none" fillRule="evenodd"><path d="M1 1h29v20H1z" /><path d="m1 1 15.467 11L30 1" /></g></svg>;
export default SvgMailIcon;